import { useReducer, useCallback } from 'react'
import * as R from 'ramda'
import effects from 'app/effects/effects'
import {
  SUBSCRIBERS,
  SUB_GROUP,
  EVERYONE_NAME,
  WITHOUT_GROUP_NAME,
} from 'app/constants/recipient'
import { getMessageRatioPayload } from '../mapping'

export const actionMessageType = {
  SET_LOADING_MESSAGE_RATIO: 'SET_LOADING_MESSAGE_RATIO',
  SET_MESSAGE_RATIO: 'SET_MESSAGE_RATIO',
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionMessageType.SET_LOADING_MESSAGE_RATIO:
      return {
        ...state,
        isLoadingMessaageRatio: true,
      }
    case actionMessageType.SET_MESSAGE_RATIO:
      return {
        ...state,
        messaageRatio: action.value,
        isLoadingMessaageRatio: false,
      }

    default:
      return state
  }
}

const initialValue = {
  isLoadingMessaageRatio: false,
  messaageRatio: {
    application: 0,
    sms: 0,
    email: 0,
    automatedCall: 0,
    social: 0,
  },
}

export const useMessageCredit = () => {
  const [state, dispatch] = useReducer(reducer, initialValue)
  /**
   * Fetch API => /message-credit >>
   */
  const fetchMessageRatio = useCallback(async (values) => {
    const groups = values.recipients.subGroups

    const subscribers = values.recipients.subscribers

    const channels = values.channels.channelIds
    const messageRatioPayload = getMessageRatioPayload(values)
    const isEmpty = R.and(R.isEmpty(groups), R.isEmpty(subscribers))
    if (isEmpty && R.isEmpty(channels)) return
    else {
      dispatch({
        type: actionMessageType.SET_LOADING_MESSAGE_RATIO,
      })
      return await effects.apis
        .getMessageRatio(messageRatioPayload)
        .then((response) => {
          dispatch({
            type: actionMessageType.SET_MESSAGE_RATIO,
            value: response,
          })
          return response
        })
        .catch((error) => {
          dispatch({
            type: actionMessageType.SET_MESSAGE_RATIO,
            value: {
              application: 0,
              sms: 0,
              email: 0,
              automatedCall: 0,
              social: 0,
            },
          })
        })
    }
  }, [])

  return {
    state,
    fetchMessageRatio,
  }
}
